import HorizontalScrollable from './HorizontalScrollable';

export default HorizontalScrollable;
